import styled, { keyframes } from "styled-components";

const StyledKeyframes = keyframes`
    50% {
        opacity: .05;
    }
`;

interface IBoneProps {
    color?: string
    height?: string
    width?: string
}

export default styled.div<IBoneProps>`
    animation: ${ StyledKeyframes } 2s linear infinite;
    background: ${ ({ color = "#000" }) => color };
    border-radius: 4px;
    height: ${ ({ height = "1rem" }) => height };
    opacity: .1;
    width: ${ ({ width = "100%" }) => width };
`;
